import {
  withTranslation,
} from 'react-i18next';

import SectionView from './SectionView';

const TranslatedComponent = withTranslation()(SectionView);

const Component = TranslatedComponent;

export default Component;
